import React, { useEffect } from 'react';
import AppHeader from '../../component/AppHeader/app-header';
import Stepper from '../../component/Stepper/Stepper';
import BillingForm from './components/BillingForm';
import OrderSummary from './components/OrderSummary';
import './Checkout.scss';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useStepper } from '../../hooks/useStepper';

const CheckoutPage = () => {
	const { steps, currentStep, goToStep } = useStepper();

	const navigate = useNavigate();

	const { selectedPlan } = useSelector((state) => state.subscription);

	useEffect(() => {
		if (!selectedPlan) {
			navigate('/subscription-plan');
		}
	}, [selectedPlan, navigate]);

	return (
		<main className="main-wrapper h-100">
			<AppHeader
				title="Complete Checkout"
				username={'Sanjay Choudhary'}
			/>
			<div className="py-4">
				<Stepper
					steps={steps}
					currentStep={currentStep}
					onStepClick={goToStep}
				/>
			</div>
			<div className="pb-5">
				<div className="checkout-container">
					<div className="checkout-grid">
						<div className="checkout-left">
							<BillingForm />
						</div>

						<div className="checkout-right">
							<OrderSummary />
						</div>
					</div>
				</div>
			</div>
		</main>
	);
};

export default CheckoutPage;
